export default "__VITE_ASSET__Cfw9SoDw__"